import { AUTH_API, handleApiError } from '../../utils/axios';

export const getRoles = async () => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/roles`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
